import React from 'react';
import { ImagesEntry, ImagesWindows } from '@shakkerai/pro-images';
import { registerComponent } from '@starflow/app/extension';
import { ZoomControls } from './Zoom';
import { CleanTool } from './Clean';
import { Hotkeys } from './Hotkeys';

registerComponent('root', { Component: ImagesWindows });

export const AssistantTools = React.memo(() => {
  return (
    <div className="absolute top-16 left-4 z-[51] flex items-center space-x-2 pointer-events-auto">
      <div className="flex items-center h-[34px] px-3 space-x-3 bg-white rounded-sm shadow-light text-xs text-[#2d2d2d]">
        <ZoomControls />
        <Hotkeys />
        <CleanTool />
      </div>
      <ImagesEntry />
    </div>
  );
});
